module.exports = __webpack_public_path__ + "static/media/man_han_mec_aid.2f8b6f86.png";